import React from 'react';
import { autobind } from 'core-decorators';
import { Row, Col } from 'src/componentes/grid';
import http from 'src/services/httpService';
import Checkbox from '../../componentes/checkbox';
import ItemOrganizacaoLookup from '../../lookups/item-organizacao';
import StatusRelatorioAcompanhamento from '../../lookups/status-relatorio-acompanhamento';
import ResponsavelLookup from '../../lookups/colaborador';
import ItemLookup from '../../lookups/item';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { capitalizeFirstLetter } from '../../utils/string';
import DesdobramentoLookup from '../../lookups/desdobramento';
import dataPeriodo from '../../utils/dataPeriodo';
import ClassificacaoRelatorioAcompanhamentoLookup from 'src/lookups/ClassificacaoRelatorioAcompanhanetoLookup';
import FarolLookup from '../../lookups/farol';
import TipoFiltroDataLookup from '../../lookups/tipo-filtro-data';
import DatePicker from '../../componentes/date-picker';
import TipoValorDesatualizadoLookup from '../../lookups/tipo-valor-desatualizado';
import TipoItemLookup from '../../lookups/tipo-item';
import PeriodicidadeLookup from '../../lookups/periodicidade';
import TagLookup from '../../lookups/TagLookup';
import PanelCollapse from 'src/componentes/panel-collapse';
import DesenharCampoCustomizado from '../item/campo-customizado/componentes/desenhar';

@autobind
class RelatorioAcompanhamentoSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: null,
      filtroDefault: {
        tipoFiltroData: {
          id: this.props.model.getModel('tipoFiltroData').value
            ? this.props.model.getModel('tipoFiltroData').value.id
            : 4,
        },
        dataInicio: this.props.model.getModel('dataInicio').value
          ? this.props.model.getModel('dataInicio').value
          : dataPeriodo.inicio,
        dataTermino: this.props.model.getModel('dataInicio').value
          ? this.props.model.getModel('dataTermino').value
          : dataPeriodo.termino,
      },
    };
  }

  componentDidMount() {
    this.props.model
      .getModel('tipoFiltroData')
      .requestChange(this.state.filtroDefault.tipoFiltroData);
    this.props.model
      .getModel('dataInicio')
      .requestChange(this.state.filtroDefault.dataInicio);
    this.props.model
      .getModel('dataTermino')
      .requestChange(this.state.filtroDefault.dataTermino);
    this.getOptionsPeriodo();
  }

  getOptionsPeriodo() {
    http
      .post(`/TipoFiltroDataLookup/Search`, {
        pageSize: 999999,
      })
      .then((response) => {
        let list = response.data.list.filter((x) => x.id !== 6);
        this.setState({
          filtroDefault: {
            ...this.state.filtroDefault,
          },
          options: list,
        });
      });
  }

  handleChangeFiltro(field, value) {
    let { model } = this.props;
    model.getModel(field).requestChange(value);
  }

  handleChangeItem(value) {
    if (value == null)
      this.props.model.getModel('desdobramento').requestChange(null);
    else
      this.props.model
        .getModel('desdobramento')
        .requestChange(value.desdobramento);

    this.props.model.getModel('itens').requestChange(value);
  }

  render() {
    let { model, resources, intl, configuracaoSistema } = this.props;

    return (
      <div style={{ padding: 0, margin: 0 }}>
        {/* ACCORDION 1: Informações básicas */}
        <PanelCollapse
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'label.informacoesBasicas' })
          )}
          open={true}
          ehAccordionDrawer={true}
        >
          {/* Itens */}
          <Row>
            <Col md={12}>
              <ItemLookup
                multi={true}
                model={{
                  label: model.getModel('itens').label,
                  value: model.getModel('itens').value,
                  requestChange: this.handleChangeItem,
                }}
                data={{ tiposIdsSelecionados: [1, 2, 3, 10, 11] }}
              />
            </Col>
          </Row>

          {/* Áreas */}
          <Row>
            <Col md={12}>
              <ItemOrganizacaoLookup
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.areas),
                  value: model.getModel('areas').value,
                  requestChange: model.getModel('areas').requestChange,
                }}
                data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              />
            </Col>
          </Row>

          {/* Considerar áreas subordinadas */}
          <Row>
            <Col md={12}>
              <Checkbox
                model={{
                  label: intl.formatMessage(
                    { id: 'label.considerarAreasSubordinadas' },
                    { areas: resources.areas }
                  ),
                  value: model.getModel('areasSubordinadas').value,
                  requestChange:
                    model.getModel('areasSubordinadas').requestChange,
                }}
                disabled={!model.getModel('areas').value}
                style={{
                  marginBottom: 16,
                }}
              />
            </Col>
          </Row>

          {/* Tipo Período */}
          <Row>
            <Col md={12}>
              <TipoFiltroDataLookup
                clearable={true}
                options={this.state.options}
                model={{
                  label: intl.formatMessage({ id: 'label.tipoFiltroData' }),
                  value: this.state.filtroDefault.tipoFiltroData,
                  requestChange: (value) => {
                    this.setState((prevState) => ({
                      filtroDefault: {
                        ...prevState.filtroDefault,
                        tipoFiltroData: value,
                      },
                    }));
                    model.getModel('tipoFiltroData').requestChange(value);
                  },
                }}
              />
            </Col>
          </Row>

          {/* Datas aparecem embaixo quando período é selecionado */}
          {model.getModel('tipoFiltroData').value &&
            model.getModel('tipoFiltroData').value.id === 1 && (
              <>
                {/* Data Início */}
                <Row>
                  <Col md={6}>
                    <DatePicker
                      model={{
                        label: intl.formatMessage({ id: 'label.dataInicio' }),
                        value: this.state.filtroDefault.dataInicio,
                        requestChange: (value) => {
                          this.setState((prevState) => ({
                            filtroDefault: {
                              ...prevState.filtroDefault,
                              dataInicio: value,
                            },
                          }));
                          model.getModel('dataInicio').requestChange(value);
                        },
                      }}
                    />
                  </Col>

                  {/* Data Termino */}
                  <Col md={6}>
                    <DatePicker
                      model={{
                        label: intl.formatMessage({ id: 'label.dataTermino' }),
                        value: this.state.filtroDefault.dataTermino,
                        requestChange: (value) => {
                          this.setState((prevState) => ({
                            filtroDefault: {
                              ...prevState.filtroDefault,
                              dataTermino: value,
                            },
                          }));
                          model.getModel('dataTermino').requestChange(value);
                        },
                      }}
                    />
                  </Col>
                </Row>
              </>
            )}

          {/* Responsáveis */}
          <Row>
            <Col md={12}>
              <ResponsavelLookup
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.responsaveis),
                  value: model.getModel('responsaveis').value,
                  requestChange: model.getModel('responsaveis').requestChange,
                }}
              />
            </Col>
          </Row>

          {/* Status - Solução de Problemas */}
          <Row>
            <Col md={12}>
              <StatusRelatorioAcompanhamento
                clearable
                data={{ idSelecionaveis: [0, 1, 2] }}
                model={model.getModel('statusRelatorioAcompanhamento')}
              />
            </Col>
          </Row>

          {/* Farol */}
          <Row>
            <Col md={12}>
              <FarolLookup
                data={{ idsIgnorados: null }}
                clearable
                model={{
                  label: capitalizeFirstLetter(resources.farol),
                  value: model.getModel('farol').value,
                  requestChange: model.getModel('farol').requestChange,
                }}
              />
            </Col>
          </Row>

          {/* Farol Acumulado */}
          <Row>
            <Col md={12}>
              <FarolLookup
                data={{ idsIgnorados: null }}
                clearable
                model={{
                  label: capitalizeFirstLetter(resources.farolAcumulado),
                  value: model.getModel('farolAcumulado').value,
                  requestChange: model.getModel('farolAcumulado').requestChange,
                }}
              />
            </Col>
          </Row>

          {/* Tipo */}
          <Row>
            <Col md={12}>
              <TipoValorDesatualizadoLookup
                clearable
                model={{
                  label: intl.formatMessage({ id: 'tipo' }),
                  value: model.getModel('tipoRelatorio').value,
                  requestChange: model.getModel('tipoRelatorio').requestChange,
                }}
              />
            </Col>
          </Row>
        </PanelCollapse>

        {/* ACCORDION 2: Informações Complementares */}
        <PanelCollapse
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'informacoesComplementares' })
          )}
          open={false}
          ehAccordionDrawer={true}
        >
          {/* Tipo de Item */}
          <Row>
            <Col md={12}>
              <TipoItemLookup
                clearable
                model={{
                  label: intl.formatMessage({ id: 'label.tipoItem' }),
                  value: model.getModel('tipoItem').value,
                  requestChange: model.getModel('tipoItem').requestChange,
                }}
                data={{
                  tiposIdSelecionaveis: [1, 3],
                }}
              />
            </Col>
          </Row>

          {/* Periodicidade do Item */}
          <Row>
            <Col md={12}>
              <PeriodicidadeLookup
                clearable
                model={{
                  label: intl.formatMessage({ id: 'periodicidade' }),
                  value: model.getModel('periodicidade').value,
                  requestChange: model.getModel('periodicidade').requestChange,
                }}
              />
            </Col>
          </Row>

          {/* Tags */}
          <Row>
            <Col md={12}>
              <TagLookup
                multi
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'tags' }, { tags: resources.tags })
                  ),
                  value: model.getModel('tags').value,
                  requestChange: model.getModel('tags').requestChange,
                }}
                data={{
                  funcionalidadesIdSelecionaveis: [1, 2, 3, 4],
                }}
                podeEditar={false}
              />
            </Col>
          </Row>

          {/* Desdobramento */}
          {configuracaoSistema.utilizarFuncionalidadeDesdobramento && (
            <Row>
              <Col md={12}>
                <DesdobramentoLookup model={model.getModel('desdobramento')} />
              </Col>
            </Row>
          )}

          {/* Tipo (Classificação) */}
          <Row>
            <Col md={12}>
              <ClassificacaoRelatorioAcompanhamentoLookup
                model={model.getModel('classificacao')}
              />
            </Col>
          </Row>
        </PanelCollapse>
        {model.getModel('camposCustomizados') &&
          model.getModel('camposCustomizados').value &&
          model.getModel('camposCustomizados').value.length > 0 && (
            <PanelCollapse
              header={capitalizeFirstLetter(
                intl.formatMessage({ id: 'camposAdicionais' })
              )}
              open={false}
              ehAccordionDrawer={true}
            >
              <Row>
                <Col md={12}>
                  <DesenharCampoCustomizado
                    model={model.getModel('camposCustomizados')}
                    mdFields={12}
                    usarFiltroMultiSelecaoListaOpcao={true}
                  />
                </Col>
              </Row>
            </PanelCollapse>
          )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    configuracaoSistema: state.user.configuracao,
  };
}
export default injectIntl(
  connect(mapStateToProps)(RelatorioAcompanhamentoSearch)
);
